/* Toronto Auto Parts — concept redesign: nav + reveal */
(function () {
  // ----- Mobile nav -----
  var toggle = document.querySelector('.nav-toggle');
  var links = document.querySelector('.nav-links');
  var scrim = document.querySelector('.nav-scrim');

  function setMenu(open) {
    if (!toggle || !links) return;
    toggle.classList.toggle('open', open);
    links.classList.toggle('open', open);
    if (scrim) scrim.classList.toggle('open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }

  if (toggle) {
    toggle.addEventListener('click', function () {
      setMenu(!links.classList.contains('open'));
    });
  }
  if (scrim) scrim.addEventListener('click', function () { setMenu(false); });

  // Collapsible make dropdowns on mobile (tap to expand, not auto-open)
  function isMobileNav(){ return window.matchMedia('(max-width:1350px)').matches; }
  document.querySelectorAll('.nav-has-dd > a').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!isMobileNav()) return;                 // desktop keeps hover behaviour
      var li = a.parentNode;
      if (li.querySelector('.nav-dd')) {
        e.preventDefault();                        // first tap opens the sub-menu
        li.classList.toggle('open');
      }
    });
  });

  // Close the side menu only when an actual navigation link is tapped
  if (links) {
    links.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        if (isMobileNav() && a.parentNode.classList.contains('nav-has-dd')) return;
        setMenu(false);
      });
    });
  }
  window.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setMenu(false);
  });

  // ----- Reveal on scroll -----
  var reveal = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveal.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveal.forEach(function (el) { io.observe(el); });
  } else {
    reveal.forEach(function (el) { el.classList.add('in'); });
  }

  // ----- Footer year -----
  var y = document.querySelector('[data-year]');
  if (y) y.textContent = new Date().getFullYear();

  // ----- Contact form (demo only) -----
  var form = document.querySelector('#quote-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var note = form.querySelector('.form-status');
      if (note) {
        note.style.display = 'block';
        note.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      form.reset();
    });
  }
})();
